import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { setDoc, doc } from "firebase/firestore";
import { toast } from "react-toastify";
import "./LoginForm.css";
import { FaUser, FaLock } from "react-icons/fa";
import SignInwithGoogle from "./signInWithGoogle";
import { useSelector, useDispatch } from "react-redux";
import { fetchData, selectIsLoading } from "../../mainApp/features/DataSlice/dataSlice";
import LoadingPage from "../components/TechnicalTabs/LoadingPage";
import ErrorPage from "../components/TechnicalTabs/ErrorPage";
import { Link, useNavigate } from "react-router-dom";
import { translateFirebaseError } from "./Utility/firebaseErrorTranslator";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false); // Śledzi proces logowania
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading === "success") {
      setInitialLoading(false);
    }
  }, [isLoading]);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user) {
        await sendEmailVerification(user);
        await setDoc(doc(db, "Users", user.uid), {
          email: user.email,
          firstName: fname,
          lastName: "",
          photo: "",
          termsAccepted: false,
        });
        await auth.signOut();
        toast.success("Rejestracja pomyślna! Sprawdź e-mail, aby aktywować konto.", {
          position: "top-center",
        });
        navigate('/email-verification', { state: { email, password } });
      }
    } catch (error) {
    
      const translatedError = translateFirebaseError(error.code, 'register');
      toast.error(translatedError, {
        position: "bottom-center",
      });
    }
  };

  let returned;

  switch (isLoading) {
    case "loading":
      returned = <LoadingPage />;
      break;
    case "success":
      returned = (
        <div className="wrapper">
          <form onSubmit={handleRegister}>
            <h1>Rejestracja</h1>
            <div className="input-box">
              <input
                type="text"
                placeholder="Imię"
                onChange={(e) => setFname(e.target.value)}
                required
              />
              <FaUser className="icon" />
            </div>

            <div className="input-box">
              <input
                type="text"
                placeholder="Nazwisko"
                onChange={(e) => setLname(e.target.value)}
              />
              <FaUser className="icon" />
            </div>

            <div className="input-box">
              <input
                type="email"
                placeholder="Wprowadź email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <FaUser className="icon" />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Wprowadź hasło"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <FaLock className="icon" />
            </div>

            <button type="submit">Zarejestruj</button>

            <div className="register-link">
              <p>
                Już zarejestrowany?{" "}
                <a href="/login">Logowanie</a>
              </p>
            </div>
            <SignInwithGoogle setIsLoggingIn={setIsLoggingIn} />
            
            <div className="legal-links">
              <Link to="/regulations">Regulamin</Link>
              <span className="separator">|</span>
              <Link to="/policy">Polityka Prywatności</Link>
            </div>
          </form>
        </div>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
}

export default Register;